export enum DateFormat {
	LONG_WITH_HOURS = 'DD/MM/YYYY [-] HH[:]mm'
}
